import { useEffect, useRef } from "react";

// FE-80 (21.10.2026): modallar erişilebilir değildi — role/aria yok, Esc kapatmıyor, Tab arka sayfaya kaçıyor,
// kapanınca odak kayboluyordu. Bu hook (ortak Modal ve kendi katmanını çizen modallar):
//  - açılınca önceki odağı saklar, odağı pencerenin KENDİSİNE verir (input'a değil: mobilde klavye açılmasın),
//  - Tab / Shift+Tab'ı pencere içinde döndürür,
//  - Esc'yi yalnız EN ÜSTTEKİ modalda ve kapatılabiliyorsa (escKapat) onClose'a bağlar,
//  - kapanınca odağı açan öğeye geri verir.
const yigin = []; // açık modallar (en üstteki sonda)
const ODAKLANABILIR = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';

export default function useModalErisim(acik, pencereRef, onClose, escKapat = true) {
  const kapatRef = useRef(onClose);
  kapatRef.current = onClose;
  useEffect(() => {
    if (!acik) return undefined;
    const pencere = pencereRef.current;
    if (!pencere) return undefined;
    const kimlik = {};
    yigin.push(kimlik);
    const onceki = document.activeElement;
    if (!pencere.contains(document.activeElement)) {
      try { pencere.focus({ preventScroll: true }); } catch (e) { pencere.focus(); }
    }
    const tus = (e) => {
      if (yigin[yigin.length - 1] !== kimlik) return;
      if (e.key === "Escape" && escKapat) {
        e.stopPropagation();
        kapatRef.current?.();
        return;
      }
      if (e.key !== "Tab") return;
      const ogeler = [...pencere.querySelectorAll(ODAKLANABILIR)].filter((el) => el.offsetParent !== null || el === document.activeElement);
      if (!ogeler.length) { e.preventDefault(); pencere.focus(); return; }
      const ilk = ogeler[0];
      const son = ogeler[ogeler.length - 1];
      if (e.shiftKey && (document.activeElement === ilk || document.activeElement === pencere)) { e.preventDefault(); son.focus(); }
      else if (!e.shiftKey && document.activeElement === son) { e.preventDefault(); ilk.focus(); }
    };
    document.addEventListener("keydown", tus, true);
    return () => {
      document.removeEventListener("keydown", tus, true);
      const i = yigin.indexOf(kimlik);
      if (i >= 0) yigin.splice(i, 1);
      if (onceki && typeof onceki.focus === "function" && document.contains(onceki)) {
        try { onceki.focus({ preventScroll: true }); } catch (e) { /* yoksay */ }
      }
    };
  }, [acik, pencereRef, escKapat]);
}
